<template>
  <div class="tw-hidden">captcha</div>
</template>

<script>
export default {
  name: "Captcha",
  data: () => ({}),
  mounted() {
    this.$emit("verify", true)
  },
}
</script>
